export default "__VITE_ASSET__B4c6tKuz__"